export default {
    learnMore: 'Learn more',
    text: {
        maintenance: 'We are currently undergoing maintance.',
        incident: 'We are working on fixing an issue.',
    },
    affected: 'Affected service | Affected services',
};
